import { render, staticRenderFns } from "./HeaderMainBasket.vue?vue&type=template&id=2e0d8b33&scoped=true&"
import script from "./HeaderMainBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderMainBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMainBasket.vue?vue&type=style&index=0&id=2e0d8b33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d8b33",
  null
  
)

export default component.exports